import { render, staticRenderFns } from "./BonusInfo.vue?vue&type=template&id=0546d467&scoped=true&"
import script from "./BonusInfo.vue?vue&type=script&lang=js&"
export * from "./BonusInfo.vue?vue&type=script&lang=js&"
import style0 from "./BonusInfo.vue?vue&type=style&index=0&id=0546d467&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0546d467",
  null
  
)

export default component.exports